import axios from "axios";
// import router from "@/router";

//TODO - Get the url from .env
const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL
});

instance.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    const token = localStorage.getItem("user-token");

    if (token && token !== "undefined")
      config.headers["Authorization"] = "token " + token;
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// instance.interceptors.response.use(undefined, function(error) {
//   //Extract error causing url, strip extrac slashes, if its `me` and unauthorized, logout the user.
//   console.log("ERROR in interceptor response");
//   console.log(error.response.status, "Status");
//   if (error.response.status === 401) {
//     localStorage.removeItem("user-token");
//     router.push({ name: "Login" });
//   }

//   return Promise.reject(error);
// });

export default instance;
